
import { NgModule } from '@angular/core';
import {
  PreloadAllModules,
  RouterModule,
  Routes,
} from '@angular/router';

import { authenticationGuard } from '@guards/authentication.guard';
import { authorizationGuard } from '@guards/authorization.guard';
import { logoutGuard } from '@guards/logout.guard';

import { AgreementViewComponent } from '@pages/agreement-view/agreement-view.component';
import { AgreementComponent } from '@pages/agreement/agreement.component';
import { BalancePage } from '@pages/balance/balance.page';
import { ContactsComponent } from '@pages/contacts/contacts.component';
import { DelegatesComponent } from '@pages/delegates/delegates.component';
import { GroupsComponent } from '@pages/groups/groups.component';
import { HomePage } from '@pages/home/home.page';
import { InfoPage } from '@pages/info/info.page';
import { LoginPage } from '@pages/login/login.page';
import { NominationComponent } from '@pages/nomination/nomination.component';
import { OrganizationChartViewComponent } from '@pages/organization-chart-view/organization-chart-view.component';
import { PermissionManagementComponent } from '@pages/permission-management/permission-management.component';
import { ProtocolPage } from '@pages/protocol/protocol.page';
import { QuestionComponent } from '@pages/question/question.component';
import { RegulationManagerComponent } from '@pages/regulation-manager/regulation-manager.component';
import { ShippingManagementComponent } from '@pages/shipping-management/shipping-management.component';
import { SubscribersPage } from '@pages/subscribers/subscribers.page';
import { UserAccessComponent } from '@pages/user-access/user-access.component';
import { UserInfoComponent } from '@pages/user-info/user-info.component';
import { VoteComponent } from '@pages/vote/vote.component';
import { InfoPageComponent } from '@pages/info-page/info-page.component';
import { ViewNominationComponent } from '@pages/view-nomination/view-nomination.component';
import { ProblemReportPageComponent } from '@pages/problem-report-page/problem-report-page.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'infoPage',
    pathMatch: 'full',
  },
  {
    path: 'infoPage',
    component: InfoPageComponent,
  },
  {
    path: 'home',
    component: HomePage,
    canActivate: [authorizationGuard],
  },
  {
    path: 'login',
    component: LoginPage,
    canActivate: [authenticationGuard],
  },
  {
    path: 'logout',
    canLoad: [logoutGuard],
    component: LoginPage,
  },
  {
    path: 'permissions',
    canLoad: [logoutGuard],
    component: PermissionManagementComponent,
  },
  {
    path: 'info',
    component: InfoPage,
    canActivate: [authorizationGuard],
  },
  {
    path: 'subscribers',
    component: SubscribersPage,
    canActivate: [authorizationGuard],
  },
  {
    path: 'balance',
    component: BalancePage,
    canActivate: [authorizationGuard],
  },
  {
    path: 'protocol',
    component: ProtocolPage,
    canActivate: [authorizationGuard],
  },
  {
    path: 'authorizations',
    component: GroupsComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'agreements',
    component: AgreementComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'agreement-view',
    component: AgreementViewComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'delegates',
    component: DelegatesComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'question',
    component: QuestionComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'vote',
    component: VoteComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'documents',
    component: ProtocolPage,
    canActivate: [authorizationGuard],
  },
  {
    path: 'organigram',
    component: OrganizationChartViewComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'contacts',
    component: ContactsComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'user-info',
    component: UserInfoComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'user-access',
    component: UserAccessComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'regulations',
    component: RegulationManagerComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'nominations',
    component: NominationComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'shippings',
    component: ShippingManagementComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'view-nomination',
    component: ViewNominationComponent,
    canActivate: [authorizationGuard],
  },
  {
    path: 'problem-report',
    component: ProblemReportPageComponent,
    canActivate: [authorizationGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
